import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import CircularProgress from '@mui/material/CircularProgress';
import Link from "@mui/material/Link";
import { useLocation, useNavigate, Link as RouterLink } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import google from "./../../assets/images/socialMedia/google.svg";
import apple from "./../../assets/images/socialMedia/apple.svg";
import facebook from "./../../assets/images/socialMedia/facebook.svg";
import {
  createFirebaseAccountWithFacebook,
  createFirebaseAccountWithGoogle,
  createFirebaseAccountWithPassword,
  validateSignupForm,
  validateFacebookEmail,
  signOut,
  getErrorMessage,
} from '../../Business/AuthenticationBusiness';
import { createFirebaseAccountWithApple } from "../../Business/AuthenticationBusiness";
import { createUser, verifyEmailFirebase } from "./../../Repository/Api";
import { getUserByEmail } from "../../Repository/Api";
import { updateEmailId } from "../../Repository/Authentication/Firebase";
import { getFirebaseAuthModule } from "../../Repository/Authentication/Firebase";
import { getFirebaseAuthJWTToken } from "../../Repository/Authentication/Firebase";
import { FacebookAuthProvider } from "firebase/auth";
import MuiAlert from '@mui/material/Alert';
import {
  readPendingQrReturn,
  savePendingQrReturn,
} from "../../Business/CamiCodeScanBusiness";

function Register(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  let _location = useLocation();

  const redirectTarget = (() => {
    const fromLocation = _location.state?.from || readPendingQrReturn();
    if (!fromLocation) {
      return { pathname: "/" };
    }
    if (_location.state?.from) {
      savePendingQrReturn(_location.state.from);
    }
    return {
      pathname: fromLocation.pathname || "/",
      search: fromLocation.search || "",
      hash: fromLocation.hash || "",
    };
  })();

  const goToLoginAfterRegister = () => {
    navigate("/login", {
      replace: true,
      state: { from: redirectTarget, registerSuccess: true },
    });
  };
  const xlPage = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 80,
    width: "400px",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: 20,
    marginBottom: 80,
    border: "1px solid #E5E7EB",
    boxShadow: "0 12px 32px rgba(24, 32, 104, 0.1), 0 2px 6px rgba(24, 32, 104, 0.04)",
    backgroundColor: "#FFFFFF",
    overflow: "hidden",
  };
  const smPage = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 1,
  };
  const errorText = {
    color: "#B01840",
    fontSize: 12.5,
    marginTop: 4,
    marginBottom: 0,
    marginLeft: 8,
  };
  const socialLogo = {
    padding: 16,
    paddingHorizontal: 20,
    height: 64,
    cursor: 'pointer'
  };
  const socialLogoContainer = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: "100%",
    my: 2,
  };
  const mainColor = theme.palette.primary.main;
  const whiteColor = "#000";
  const inputFieldColor = "#EEF0F3";
  const ColorButton = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 999,
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(176, 24, 64, 0.28)",
    transition: "background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      boxShadow: "0 6px 18px rgba(176, 24, 64, 0.35)",
      transform: "translateY(-1px)",
    },
  }));

  const passwordConditionsStyle = {
    fontSize: 12,
    paddingTop: 10,
    marginLeft: 5,
    marginRight: 5
  }
  const inputFieldSx = {
    width: "100%",
    mt: 1.5,
    backgroundColor: inputFieldColor,
    paddingBlock: 1.15,
    paddingInlineStart: 1.5,
    paddingInlineEnd: 1.5,
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&.Mui-focused": {
      borderColor: "#B01840",
      boxShadow: "0 0 0 3px rgba(176, 24, 64, 0.12)",
    },
    "& input::ms-reveal, & input::-ms-clear": {
      display: "none",
    },
  };
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    showPassword: false,
    showConfirmPassword: false,
    confirmPassword: "",
    company: ""
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isMessage, setIsMessage] = useState(false)
  const [showUi, setShowUi] = useState(false);
  const [emailOfUser, setEmailOfUser] = useState("");
  const [authId, setAuthId] = useState("");
  const [signInMethod, setSignInMethod] = useState("");
  const [firstName, setFirstName] = useState("")
  const [isEmailSubmit, setEmailSubmit] = useState(false);

  const handleCloseAlert = () => {
    setIsMessage(false);
    goToLoginAfterRegister();
  };

  const finishRegistrationSuccess = async () => {
    setIsSubmit(false);
    setEmailSubmit(false);
    setApiError("");
    setFormValues(initialValues);
    // Registration signs the user in via Firebase; sign out so Login does not
    // auto-redirect and the user can complete the login step explicitly.
    try {
      await signOut();
    } catch (error) {
      // ignore sign-out failures; still show success + login navigation
    }
    setIsMessage(true);
    // Smoothly hand off to the login page with a success banner.
    setTimeout(() => {
      goToLoginAfterRegister();
    }, 1800);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleClickShowPassword = () => {
    setFormValues({
      ...formValues,
      showPassword: !formValues.showPassword,
    });
  };

  useEffect(() => {
    reDirectFromUrl();
  }, []);

  function reDirectFromUrl() {
    const urlSearchParams = new URLSearchParams(window.location.search.toString().slice(1));
    if (urlSearchParams.has("email")) {
      const emailOfReceiver = urlSearchParams.get('email').replace(/ /g, '');
      setFormValues({ ...formValues, "email": emailOfReceiver != "" ? emailOfReceiver : "" })
    }
  }
  const handleClickShowConfirmPassword = () => {
    setFormValues({
      ...formValues,
      showConfirmPassword: !formValues.showConfirmPassword,
    });
  };
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const validation = validateSignupForm(formValues);
    setFormErrors(validation.errorList);
    if (validation.status === true) {
      setIsSubmit(true);
      setIsMessage(false);
      createFirebaseAccountWithPassword(formValues)
        .then(async () => {
          e.stopPropagation();
          if (typeof props['type'] == 'undefined' && props['type'] != 'imported') {
            await finishRegistrationSuccess();
          } else {
            setIsSubmit(false);
            setIsMessage(true);
          }
        })
        .catch((error) => {
          setIsSubmit(false);
          setIsMessage(false);
          setApiError(getErrorMessage(error));
        });
    }
  };

  const handleGoogleLogin = (e) => {
    setIsSubmit(true);
    setIsMessage(false);
    createFirebaseAccountWithGoogle()
      .then(async () => {
        if (typeof props['type'] == 'undefined' && props['type'] != 'imported') {
          await finishRegistrationSuccess();
        } else {
          setIsSubmit(false);
          setIsMessage(true);
        }
      })
      .catch((error) => {
        setIsSubmit(false);
        setIsMessage(false);
        setApiError(getErrorMessage(error));
      });
  }

  const handleFacebookLogin = (e) => {
    setIsSubmit(true);
    setIsMessage(false);
    createFirebaseAccountWithFacebook()
      .then((response) => {
        console.log(response, "handleFacebookLogin Response")
        const credential = FacebookAuthProvider.credentialFromResult(response);
        const token = credential.accessToken;
        const user = response.user;
        const auth = getFirebaseAuthModule();
        let email = response.user.email;
        getUserByEmail(email).then(async (response) => {
          console.log(response, "email exist or not")
          e.stopPropagation();
          if (typeof props['type'] == 'undefined' && props['type'] != 'imported') {
            await finishRegistrationSuccess();
          } else {
            setIsSubmit(false);
            setIsMessage(true);
          }
        }).catch((error) => {
          console.log(error, "No account in DB. So creating User")
          return new Promise((resolve, reject) => {
            getFirebaseAuthJWTToken(auth)
              .then((IDTOKEN) => {
                verifyEmailFirebase(user.uid).then((res) => {
                  console.log(res);
                })
                localStorage.setItem("logintype", "facebook");
                localStorage.setItem("FBUC", user);
                localStorage.setItem("JWTTOKEN", IDTOKEN);
                setAuthId(user.uid);
                setSignInMethod(credential.signInMethod);
                setEmailOfUser(user.email)
                setFirstName(user.displayName);
                if (user.email !== null || undefined || '') {
                  setShowUi(false)
                  const createUserData = {
                    authId: user.uid,
                    signInMethod: credential.signInMethod,
                    email: user.email,
                    firstName: user.displayName,
                    lastName: "",
                    userTypeId: 1,
                    userRoleId: 0,
                    createdBy: 0,
                    recordStatus: true,
                    registerStatus: true,

                  };
                  createUser(createUserData)

                    .then(async (response) => {
                      console.log(response, "respFaceBook")
                      resolve(response);
                      console.log("account created2 FaceBook")
                      if (typeof props['type'] == 'undefined' && props['type'] != 'imported') {
                        await finishRegistrationSuccess();
                      } else {
                        setIsSubmit(false);
                        setIsMessage(true);
                      }
                    })
                    .catch((error1) => {
                      console.log(error1, "error1FaceBook")
                      setIsSubmit(false);
                      reject(error1);
                    });
                } else {
                  console.log('no email in this facebook account')
                  setIsSubmit(false);
                  setShowUi(true)
                  console.log("update");

                }
              })
              .catch((error3) => {
                console.log(error3, "error3FaceBook")
                console.log("account created1 FaceBook")
                setIsSubmit(false);
                reject(error3);
              });
          })
        })
      }).catch((error) => {
        setIsSubmit(false);
        setIsMessage(false);
        setApiError(getErrorMessage(error));
      })
  }



  const handleAppleLogin = (e) => {
    setIsSubmit(true);
    setIsMessage(false);
    createFirebaseAccountWithApple()
      .then(async () => {
        if (typeof props['type'] == 'undefined' && props['type'] != 'imported') {
          await finishRegistrationSuccess();
        } else {
          setIsSubmit(false);
          setIsMessage(true);
        }
      })
      .catch((error) => {
        setIsSubmit(false);
        setIsMessage(false);
        setApiError(getErrorMessage(error));
      });
  }

  const handleSubmitEmail = (e) => {

    if (emailOfUser) {
      const createUserData = {
        "authId": authId,
        "signInMethod": signInMethod,
        "email": emailOfUser,
        "firstName": firstName,
        "lastName": "",
        "userTypeId": 1,
        "userRoleId": 0,
        "createdBy": 0,
        "recordStatus": true,
        "registerStatus": true,
      };
      const validation = validateFacebookEmail(createUserData);
      if (validation.status === true) {
        setIsSubmit(true);
        createUser(createUserData)
          .then((response) => {
            updateEmailId(emailOfUser);
            console.log(response, 'created User in DB');
          }).then(async () => {
            if (typeof props['type'] == 'undefined' && props['type'] !== 'imported') {
              await finishRegistrationSuccess();
            } else {
              setIsSubmit(false);
              setIsMessage(true);
            }
          })
          .catch((error) => {
            setIsSubmit(false);
            setApiError(getErrorMessage(error));
            console.log(error, 'err');
          });
      }
    }
  }

  /**HTML Section */
  const renderSignUpForm = () => {
    if (matches) {
      return (
        <Box elevation={0} style={smPage}>
          <ThemeProvider theme={theme}>
            <Container
              component="main"
              maxWidth="xs"
              sx={{
                marginTop: 8,
                marginBottom: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CssBaseline />
              <Box >
                {/* <Typography
                  variant="h5"
                  sx={{
                    textAlign: "left",
                    alignItems: "flex-start",
                    color: theme.palette.primary.main,
                  }}
                >
                  Sign Up
                </Typography> */}
                {showUi == false && renderSignUpFormContent()}
                {showUi == true && renderGetEmailFromUser()}
              </Box>
            </Container>
          </ThemeProvider>
        </Box>
      );
    } else {
      return (
        <Paper elevation={2} style={xlPage}>
          <ThemeProvider theme={theme}>
            <Container
              component="main"
              maxWidth="xs"
              sx={{
                width: "100%",
                marginTop: 8,
                marginBottom: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CssBaseline />
              <Box>
                {/* <Typography
                  variant="h5"
                  sx={{
                    textAlign: "left",
                    alignItems: "flex-start",
                    color: theme.palette.primary.main,
                  }}
                >
                  Sign Up
                </Typography> */}
                {showUi == false && renderSignUpFormContent()}
                {showUi == true && renderGetEmailFromContent()}
              </Box>

            </Container>
          </ThemeProvider>
        </Paper>
      );
    }
  };


  const renderGetEmailFromContent = () => {
    if (isSubmit === true) {
      return (
        <Box sx={{ textAlign: "center" }} >
          <CircularProgress sx={{
            marginTop: 3,
            marginBottom: 3,
            marginLeft: "auto",
            marginRight: "auto"
          }} />
        </Box>
      );
    } else {
      return (<>{renderGetEmailFromUser()}</>);
    }
  }

  const renderGetEmailFromUser = () => {
    if (showUi == true) {
      return (

        <>
          <Typography
            variant="h5"
            sx={{
              textAlign: "left",
              marginLeft: "auto",
              marginRight: "auto",
              color: theme.palette.primary.main, mb: 2
            }}
          >
            Please enter your email ID to Create account!
          </Typography>
          <Box
            component="form"
            noValidate
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "auto",
              marginRight: "auto",
              mb: 2,
            }}
          >
            <InputBase
              size="small"
              id="user email"
              placeholder="Email"
              name="user email"
              autoComplete="email"
              autoFocus
              disabled={isSubmit}
              value={emailOfUser}
              onChange={(e) => { setEmailOfUser(e.target.value) }}
              sx={inputFieldSx}
            />
            <ColorButton
              onClick={handleSubmitEmail}
              disabled={isSubmit}
              sx={{
                borderRadius: 30,
                width: 140,
                mt: 2,
              }}
              variant="contained"
            >
              CONTINUE
            </ColorButton>
          </Box>
        </>
      )

    }
  }

  const renderSignUpFormContent = () => {
    if (isSubmit === true) {
      return (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress
            sx={{
              marginTop: 1,
              marginBottom: 3,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </Box>
      );
    }

    if (isMessage === true) {
      return (
        <Box
          sx={{
            position: "fixed",
            top: { xs: 300, md: 240 },
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            width: {
              xs: "calc(100% - 32px)",
              sm: 420,
              md: 450,
            },
            maxWidth: "450px",
          }}
        >
          <Alert
            onClose={handleCloseAlert}
            severity="success"
            sx={{
              width: {
                xs: "100%",
                sm: "90%",
                md: "100%",
              },
              maxWidth: {
                xs: "100%",
                sm: 450,
              },
              mx: "auto",
              borderRadius: {
                xs: 2,
                sm: 1,
              },
              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "15px",
              },
              "& .MuiAlert-message": {
                width: "100%",
                wordBreak: "break-word",
                textAlign: "center",
              },
              "& .MuiAlert-icon": {
                alignItems: "center",
              },
            }}
          >
            Register successfully
          </Alert>
        </Box>
      );
    }

    return <>{SignUpFormContent()}</>;
  };

  const SignUpFormContent = () => {
    return (
      <>
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 700,
            letterSpacing: "-0.02em",
          }}
        >
          Create Account
        </Typography>
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            fontSize: "0.925rem",
            mb: 1,
          }}
        >
          Join Bezohminds and start sharing your story
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <InputBase
            size="small"
            id="firstName"
            placeholder="First name"
            name="firstName"
            autoComplete="given-name"
            autoFocus
            disabled={isSubmit}
            value={formValues.firstName}
            onChange={handleChange}
            sx={inputFieldSx}
          />
          {formErrors.firstName && (
            <p style={errorText}>{formErrors.firstName}</p>
          )}
          <InputBase
            size="small"
            id="lastName"
            placeholder="Last name"
            name="lastName"
            autoComplete="family-name"
            disabled={isSubmit}
            value={formValues.lastName}
            onChange={handleChange}
            sx={inputFieldSx}
          />
          {formErrors.lastName && (
            <p style={errorText}>{formErrors.lastName}</p>
          )}
          <InputBase
            size="small"
            id="company"
            placeholder="Company (Optional)"
            name="company"
            autoComplete="organization"
            disabled={isSubmit}
            value={formValues.company}
            onChange={handleChange}
            sx={inputFieldSx}
          />
          <InputBase
            size="small"
            id="email"
            placeholder="Email"
            name="email"
            autoComplete="email"
            disabled={isSubmit}
            value={formValues.email}
            onChange={handleChange}
            sx={inputFieldSx}
          />
          {formErrors.email && <p style={errorText}>{formErrors.email}</p>}
          {formErrors.emailValid && <p style={errorText}>Please enter a valid email address</p>}

          <InputBase
            size="small"
            name="password"
            placeholder="Password"
            type={formValues.showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="new-password"
            disabled={isSubmit}
            value={formValues.password}
            onChange={handleChange}
            sx={inputFieldSx}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {formValues.showPassword ?  <Visibility />  : <VisibilityOff /> }
                </IconButton>
              </InputAdornment>}
          />

          {formErrors.passwordValid && (<p style={errorText}>{formErrors.passwordValid}</p>)}

          {!formErrors.passwordValid && (<p style={passwordConditionsStyle}>Use 8 or more characters with a mix of letters, numbers & symbols</p>)}

          <InputBase
            size="small"
            name="confirmPassword"
            placeholder="Confirm Password"
            type={formValues.showConfirmPassword ? 'text' : 'password'}
            id="confirm_Password"
            autoComplete="new-password"
            disabled={isSubmit}
            value={formValues.confirmPassword}
            onChange={handleChange}
            sx={inputFieldSx}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                  edge="end"
                >
                  {formValues.showConfirmPassword ? <Visibility /> :  <VisibilityOff /> }
                </IconButton>
              </InputAdornment>}
          />

          {formErrors.password && (
            <p style={errorText}>{formErrors.password}</p>
          )}
          {apiError && <p style={errorText}>{apiError}</p>}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 3,
              marginBottom: 2,
              marginLeft: "auto",
              marginRight: "auto",
              width: "100%",
            }}
          >
            <ColorButton
              type="submit"
              disabled={isSubmit}
              sx={{
                borderRadius: 30,
                width: "100%",
                maxWidth: 280,
                margin: 3,
              }}
              variant="contained"
            >
              CREATE ACCOUNT
            </ColorButton>
          </div>
          <Box style={socialLogoContainer}>
            <Box
              component="span"
              role="button"
              aria-label="Sign up with Google"
              tabIndex={0}
              onClick={handleGoogleLogin}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleGoogleLogin(e); } }}
              sx={{ cursor: "pointer", opacity: isSubmit ? 0.6 : 1, pointerEvents: isSubmit ? "none" : "auto" }}
            >
              <img src={google} style={socialLogo} alt="Google" />
            </Box>
            <Box
              component="span"
              role="button"
              aria-label="Sign up with Apple"
              tabIndex={0}
              onClick={handleAppleLogin}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleAppleLogin(e); } }}
              sx={{ cursor: "pointer", opacity: isSubmit ? 0.6 : 1, pointerEvents: isSubmit ? "none" : "auto" }}
            >
              <img src={apple} style={socialLogo} alt="Apple" />
            </Box>
            <Box
              component="span"
              role="button"
              aria-label="Sign up with Facebook"
              tabIndex={0}
              onClick={handleFacebookLogin}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { handleFacebookLogin(e); } }}
              sx={{ cursor: "pointer", opacity: isSubmit ? 0.6 : 1, pointerEvents: isSubmit ? "none" : "auto" }}
            >
              <img src={facebook} style={socialLogo} alt="Facebook" />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              mt: 1,
            }}
          >
            <Typography variant="body2" sx={{ color: "black" }}>
              Already have an account?{" "}
            </Typography>
            <Link
              component={RouterLink}
              to="/login"
              variant="body2"
              color="inherit"
              sx={{ color: theme.palette.primary.main, ml: 0.5 }}
            >
              Log in
            </Link>
          </Box>
        </Box>
      </>
    );
  };

  return <>{renderSignUpForm()}</>;
}
export default Register;
